import type { RouteMatch } from '@confluence/route/entry-points/Route';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery';
import { preloadSpacesList } from '@confluence/space-utils/entry-points/preloadSpacesList';

export async function preloadAdvancedSearchRoute(_match: RouteMatch) {
	const tasks: Promise<any>[] = [];

	const preloadedSessionContext = getPreloaderFnContext();
	const { accessStatus } = preloadedSessionContext;

	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	tasks.push(preloadSpacesList({ isLicensed }));

	return waitForAllReturnWhenError(tasks);
}
